export default "__VITE_ASSET__CC8FWy1G__"